import React, { useRef, useEffect } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

type RichTextEditorProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  readOnly?: boolean;
  onReady?: () => void;
};

const placeholderOptions = [
  { label: '@@SenderName@@', description: 'Sender of the mail' },
  { label: '@@ReceiverName@@', description: 'User being referenced' },
  { label: '@@RequestDate@@', description: 'Date of the request' },
  { label: '@@RComment@@', description: 'Comment of the user' },
  { label: '@@AdminName@@', description: 'The name of the Admin to whome this request will be sent' },
  { label: '@@UserEmail@@', description: 'Email Id of the User' },
  { label: '@@UserID@@', description: 'User Id' }
];

const modules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['link', 'image'],
    ['clean']
  ],
};

const formats = [
  'header', 'bold', 'italic', 'underline', 'strike',
  'list', 'bullet', 'link', 'image'
];

const RichTextEditor: React.FC<RichTextEditorProps> = ({
  value,
  onChange,
  placeholder = 'Start typing...',
  readOnly = false,
  onReady,
}) => {
  const quillRef = useRef<ReactQuill | null>(null);
  const readyCalledRef = useRef(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (quillRef.current && !readyCalledRef.current && onReady) {
        readyCalledRef.current = true;
        onReady();
      }
    }, 300);
    
    return () => clearTimeout(timer);
  }, [onReady]);

  const insertPlaceholder = (text: string) => {
    const editor = quillRef.current?.getEditor();
    if (editor) {
      const range = editor.getSelection(true);
      if (range) {
        editor.insertText(range.index, text, 'user');
        editor.setSelection(range.index + text.length);
      }
    }
  };

  return (
    <div className="quill-wrapper">
      <ReactQuill
        ref={quillRef}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        readOnly={readOnly}
        modules={modules}
        formats={formats}
        theme="snow"
      />

      <div className="mt-2 placeholder-dropdown-wrapper">
        <select
          className="form-select w-auto"
          onChange={(e) => {
            const value = e.target.value;
            if (value) {
              insertPlaceholder(value);
              e.target.selectedIndex = 0;
            }
          }}
        >
          <option value="">Insert Placeholder...</option>
          {placeholderOptions.map((ph, idx) => (
            <option key={idx} value={ph.label}>
              {ph.label} – {ph.description}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default RichTextEditor;